import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import PageTitle from "../components/PageTitle";
import { ActionButton, Buttons } from "../components/Buttons";
import { TextInputForm } from "../components/Forms";
import { FaMagnifyingGlass } from "react-icons/fa6";
import TableUI from "../components/TableUI";
import { HiOutlineDotsVertical } from "react-icons/hi";
import { LuPrinter } from "react-icons/lu";
import { fetchGroupedInvoices } from "../slices/invoiceSlice";
import NotifyData from "../components/NotifyData";
import Pagnation from "../components/Pagnation";
import { useNavigate } from "react-router-dom";

const Invoice = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { groupedInvoices } = useSelector((state) => state.invoice);

  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  // Fetch data on mount
  useEffect(() => {
    dispatch(fetchGroupedInvoices());
  }, [dispatch]);

  // Filter invoices by search
  const filteredGroupedInvoices =
    groupedInvoices?.filter((item) =>
      item?.agent_name?.toLowerCase().includes(searchTerm.toLowerCase())
    ) || [];

  // Pagination Logic
  const total = filteredGroupedInvoices.length;
  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  const currentData = filteredGroupedInvoices.slice(startIndex, endIndex);

  // View invoices handler
  const handleViewInvoices = (agentName) => {
    navigate(`/agent-invoices/${encodeURIComponent(agentName)}`);
  };

  // Add invoice handler
  const handleNavigate = () => {
    navigate("/create-invoice");
  };

  // Table Headers
  const InvoiceHead = [
    "S.No",
    "Agent Name",
    // "Total Purchase Amount",
    "Total Balance Amount",
  ];

  // Table Data
  const InvoiceData = currentData.map((item, index) => ({
    values: [
      startIndex + index + 1,
      item.agent_name,
      // `Rs.${(item.total_purchase || 0).toFixed(2)}`,
      `Rs.${(item.total_balance || 0).toFixed(2)}`,
      <ActionButton
        options={[
          {
            label: "View Invoices",
            icon: <LuPrinter />,
            onClick: () => handleViewInvoices(item.agent_name),
          },
        ]}
        label={<HiOutlineDotsVertical />}
      />,
    ],
  }));

  return (
    <div id="main">
      <Container fluid>
        <Row>
          {/* Page Title */}
          <Col lg="6" className="py-3">
            <PageTitle PageTitle="Invoices" showButton={false} />
          </Col>

          {/* Add Invoice Button */}
          <Col lg="6" className="py-3 text-end">
            <Buttons
              label="Add Invoice"
              classname="crud-btn"
              OnClick={handleNavigate}
            />
          </Col>

          {/* Search by Agent */}
          <Col lg="3" className="align-self-center py-3">
            <TextInputForm
              prefix_icon={<FaMagnifyingGlass />}
              PlaceHolder="Search by Agent Name"
              className="form-control-padleft"
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setCurrentPage(1); // reset page on search
              }}
            />
          </Col>

          {/* Invoice Table */}
          <Col lg="12" xs="12">
            <TableUI
              headers={InvoiceHead}
              body={InvoiceData}
              className="table-end"
            />
          </Col>

          {/* Pagination */}
          <Col lg="12" xs="12" className="d-flex justify-content-end py-3">
            <Pagnation
              total={total}
              currentPage={currentPage}
              pageSize={pageSize}
              onPageChange={(page) => setCurrentPage(page)}
              onPageSizeChange={(current, size) => {
                setPageSize(size);
                setCurrentPage(1);
              }}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Invoice;
